import React from 'react';

import styles from './pageitem.module.scss';

interface Props {
  pageNumber: number;
  isActive: boolean;
  handleChangePage: (pageNumber: number) => void;
  isPagesIndicator?: boolean;
  useXsView?: boolean;
}

const PageItem = ({ pageNumber, isActive, handleChangePage, isPagesIndicator, useXsView }: Props) => {
  // handlers
  const changePageHandler = () => {
    if (!isActive) {
      handleChangePage(pageNumber);
    }
  }

  // helpers
  const getXsClass = () => {
    if (useXsView) {
      return ` ${styles.xs}`;
    } else {
      return "";
    }
  }
  
  // render
  if (isPagesIndicator) {
    return (
      <li className={`page-item disabled`}>
        <span className={`page-link ${styles.pageBtn}${getXsClass()}`}>
          ...
        </span>  
      </li>
    )
  } else {
    return (
      <li className={`page-item ${isActive ? " active" : ""}`}>
        <button className={`page-link ${styles.pageBtn}${getXsClass()}`} onClick={changePageHandler}>
          {pageNumber}
        </button>  
      </li>
    )
  }
}

export default PageItem;
